function calculatePercentage(obtainedMarks, maxMarks) {
    const obtainedValue = Number(obtainedMarks);
    const maxValue = Number(maxMarks);

    if (!Number.isFinite(obtainedValue) || !Number.isFinite(maxValue) || maxValue === 0) {
        return 0;
    }

    // Calculate the raw percentage
    const rawPercentage = (obtainedValue / maxValue) * 100;
  
    // Round the raw percentage to two decimal places
    const roundedPercentage = Math.round(rawPercentage * 100) / 100;
  
    return roundedPercentage;
}
export default calculatePercentage;
